var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3331 13.5831V8.9999C17.3331 6.64292 17.3331 5.46444 16.6008 4.73222C15.8686 4 14.6901 4 12.3332 4H8.9999C6.64292 4 5.46444 4 4.73222 4.73222C4 5.46444 4 6.64292 4 8.9999V15.6664C4 18.0234 4 19.2019 4.73222 19.9341C5.46444 20.6663 6.64292 20.6663 8.9999 20.6663H11.4998",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5832 4H7.75C7.75 5.17848 7.75 5.76773 8.11611 6.13384C8.48222 6.49995 9.07146 6.49995 10.2499 6.49995H11.0833C12.2617 6.49995 12.851 6.49995 13.2171 6.13384C13.5832 5.76773 13.5832 5.17848 13.5832 4Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 14.8333H10.6668M7.3335 11.5H14",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 18.9973C13.167 18.9973 14.0003 18.9973 14.8336 20.664C14.8336 20.664 16.6473 16.4974 19.0002 15.6641",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSummaryIcon);
export default __webpack_public_path__ + "static/media/project_summary_icon.705234fc18c4b2be14288c734ad79e00.svg";
export { ForwardRef as ReactComponent };